import React, { useEffect, useState } from "react";

export type LoadingProps = {
  type?: "loading" | "error" | "paused" | "disconnected" | "none";
  heading?: string;
  subHeading?: string;
  button?: {
    label: string;
    onClick: () => Promise<void>;
  };
};

const FullScreenLoader = ({ type, heading, subHeading, button }: LoadingProps) => {
  let bgColor: string;
  let defaultHeading: string;
  let image: any;

  switch (type) {
    case "loading":
      bgColor = "bg-success-subtle";
      defaultHeading = "Please wait...";
      break;

    case "error":
      bgColor = "bg-danger-subtle";
      defaultHeading = "Something went wrong!";
      image = <i className="icon-ss-error"/> ;
      break;
    case "disconnected":
      bgColor = "bg-white";
      defaultHeading = "Disconnected";
      image =  <i style={{fontSize: 140}} className="icon-ss-disconnected"/>;
      break;
    case "paused":
      bgColor = "bg-paused-subtle";
      defaultHeading = "Paused, Please wait...";
      image = <i className="icon-ss-paused"/>;
      break;
    default:
      bgColor = "bg-white";
      defaultHeading = "Screen Sharing";
  }

  const [counter, setCounter] = useState(0);
  const [delay, setDelay] = useState(50);

  useEffect(() => {
    if (counter < 100) {
      const timer = setTimeout(() => {
        setCounter((prev) => prev + 1);
        setDelay((prevDelay) => prevDelay + 5);
      }, delay);
      return () => clearTimeout(timer); // Cleanup to prevent overlapping timers
    }
  }, [counter, delay]);

  return (
    <div className={`${bgColor} fullpage-loader spinner-loader d-flex screen-sharing-host-view`} id={"floorplanner-spinner-"}>
      {/* SPINNER */}
      {type === "loading" && (
        <div className="spinner-loading">
          <div className="spinner"></div>
          <div className="spinner-value">
            <span>{counter}</span>%
          </div>
        </div>
      )}

      {image && (
        <div className={`status-image-container ${type}`}>
          {image}
          <div className="circle1"></div>
          <div className="circle2"></div>
          <div className="circle3"></div>
        </div>
      )}

      <div>
        {/* HEADING */}
        <h6
          style={{
            color: type === "error" ? "#D5121A" : "#000000"
          }}
          className="heading-text"
        >
          {heading || defaultHeading}
        </h6>

        {/* SUB-HEADING */}
        <p className="sub-heading-text">{subHeading ? subHeading : ""}</p>

        {/* BUTTON */}
        {button && (
          <button
            style={
              type === "error"
                ? {
                    color: "#444444",
                    borderColor: "#CCCCCC",
                    backgroundColor: "transparent",
                    marginTop: "20px !important"
                  }
                : {}
            }
            onClick={async () => button.onClick()}
            className="btn btn-primary mt-2"
          >
            {button.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default FullScreenLoader;
